<template>
  <div class="app-container">
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="套餐名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ membertype(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>
      <el-table-column label="点数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.vip_point }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="可获得奖励代数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.can_receive_reward_gene_num }}
        </template>
      </el-table-column> -->
      <el-table-column label="奖励代数" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.distribution_reward_gene_num }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="SHOPLAZZA商品ID" width="160">
        <template slot-scope="scope">
          {{ scope.row.product_id }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="Number(scope.row.is_on) == 1" type="success"
            >上架中</el-tag
          >
          <el-tag v-else-if="Number(scope.row.is_on) == 0" type="warning"
            >已下架</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="220"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="edit(scope.row)">
            修改
          </el-button>
          <el-button
            type="primary"
            size="mini"
            @click="changeStatus(scope.row)"
          >
            {{ Number(scope.row.is_on) == 1 ? '下架' : '上架' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: '',
      },
    }
  },
  computed: {
    membertype() {
      return (val) => {
        switch (val) {
          case 'franchise_a':
            return '加盟套餐A'
          case 'active_a':
            return '活跃套餐A'
          case 'franchise_b':
            return '加盟套餐B'
          case 'active_b':
            return '活跃套餐B'
        }
      }
    },
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    changeStatus(row) {
      let str
      if (Number(row.is_on) == 1) {
        str = '是否下架该套餐?'
      } else {
        str = '是否上架该套餐?'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/vipProduct/changeStatus',
            method: 'post',
            data: {
              id: row.id,
              is_on: row.is_on == 1 ? 0 : 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/vipProduct/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/setshipplan?id=' + val.id)
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
